import { Dialog, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(3),
    width: theme.spacing(48),
    minWidth: theme.spacing(20),
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.grey[900],
  },
}));
